module.exports = __webpack_public_path__ + "res/dummy_reels.dc84bebc350e06cb8ee51a5c500128f6.jpg";